import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { auth } from '@hobs/auth/reducer';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { loadingReducer as loading } from '@hobs/utils/loading';
import attachment from '@hobs/reducers/attachment';
import phases from '@hobs/reducers/phases';
import odata from '@hobs/reducers/odata';
import annex from '@hobs/reducers/annex';
import parties from '@hobs/reducers/parties';
import users from '@hobs/reducers/users';
import units from '@hobs/reducers/units';
import discussion from '@hobs/reducers/discussion';
import gridSelections from '@hobs/reducers/gridSelections';
import subcontractor from '@hobs/reducers/subcontractor';
import subcontractors from '@hobs/reducers/subcontractors';
import exercises from '@hobs/reducers/exercises';
import assignmentServiceRequest from '@hobs/reducers/assignmentServiceRequest';
import serviceRequests from '@hobs/reducers/serviceRequests';
import exercise from '@hobs/reducers/exercise';
import orders from '@hobs/reducers/orders';
import invoices from '@hobs/reducers/invoices';
import reports from '@hobs/reducers/reports';
import notifications from '@hobs/reducers/notifications';

export default history =>
  combineReducers({
    auth,
    exercise,
    exercises,
    subcontractor,
    subcontractors,
    phases,
    odata,
    annex,
    users,
    units,
    parties,
    gridSelections,
    discussion,
    router: connectRouter(history),
    loadingBar: loadingBarReducer,
    loading,
    assignmentServiceRequest,
    serviceRequests,
    orders,
    attachment,
    invoices,
    reports,
    notifications
  });
